import { Text3D } from "@react-three/drei";
import { animated } from "@react-spring/three";

export default function GulToken(props) {

  return <animated.group {...props}>
  <group name='move-token' >
      <Text3D
        font="/fonts/Luckiest Guy_Regular.json"
        rotation={[Math.PI/2, Math.PI, Math.PI/2]}
        position={[-0.17,-0.01,-0.13]}
        size={0.4}
        height={0.1}
      >
        3
        <meshStandardMaterial color="orange"/>
      </Text3D>
      <mesh rotation={[0, 0, 0]}>
        <cylinderGeometry args={[0.4, 0.4, 0.1]}/>
        <meshStandardMaterial color='orange'/>
      </mesh>
      <mesh rotation={[0, 0, 0]}>
        <cylinderGeometry args={[0.35, 0.35, 0.11]}/>
        <meshStandardMaterial color='black' opacity={1}/>
      </mesh>
    </group>
  </animated.group>
}